// France
export const locale = {
  TRANSLATOR: {
    HOME: "Accueil",
    LINES: "Lignes de production",
    LINE: "Ligne de production",
    LINEID: "Lijn ID",
    OVERVIEWLINE: "Ligne overview",
    LASTCHECK: "Dernier check",
    LAST_INSPECTED: "Dernière inspection",
    VIEW_ALL: "Voir tous",
    CLEAR: "Reset",
    EDIT: "Modifier",
    SAVE: "Enregistrer",
    JUST_CHANGED: "All good",
    BE_CAREFULL: "A Prévoir",
    MUST_CHANGE: "A changer",
    CHANGE_STATUS_FOR_ENTIRE: "Changer le statut complet du",
    NOW_ITS: "maintenant c'est",
    UNCHANGED: "inchangé",
    SEARCH: "Rechercher...",
    GETQUOTE: "Demander devis",
    HIDEQUOTE: "Masquer devis",
    GETQUOTETOOLTIP: "Recevez un devis pour remplacer vos pièces",
    INSPECT_BUTTON: "Inspecter",
    STATUS: "Statut",
    AMOUNT: "Nombre",
    TOTAL_LENGTH: "Longueur total (mm)",
    NOTES: "Commentaire",
    STOCK_LOCATION: "Point de stockage",
    TRACKS: "Piste(s)",
    SERIES: "Série",
    WIDTH: "Largeur",
    HIGH: "Hauteur",
    DIAMETER: "Diamètre",
    OUTSIDE_DIAMETER: "Diamètre ext",
    COLOR: "Couleur",
    RED: "Rouge",
    ORANGE: "Orange",
    GREEN: "Vert",
    TOTAL: "Total",
    LENGTH: "Longueur",
    CONVEYOR: "Conveyor",
    SECTION: "Section",
    NAME: "Nom",
    NUMBEROFTRACKS: "Nombre(s) de lignee(s)",
    CATEGORIES: "Catégories",
    ADD_EXTRA_NOTE_HERE: "Ajoutez un commentaire ici...",
    CHOOSEFILEDROP: "Déposez votre fichier ici...",
    OPEN: "Ouvrir",
    OPEN_PDF: "Open .pdf",
    UPLOAD_PDF: "Upload .pdf",
    UPLOAD: "Envoyer",
    MAINTENANCE_HISTORY: "Historique des maintenances",
    MAINTENANCE: "Maintenance",
    TERMSANDCONDITIONS: "Terms and Conditions",
    TERMSANDCONDITIONS_URL: "https://app.max-lineconnected.com/media/Algemene%20voorwaarden%20241218%20v1%20Max-Line%20Maintenance%20and%20Trading%20BV-EN.pdf",
    TECHNICALPARTS: "Technical parts",
    SEEDETAILS: "Plus d'info",
    PREV: "Précédent",
    NEXT: "Suivant",
    SELECT: "choisissez votre langue"
  },
  PARTS: {
    PARTS: "Parts",
    Motor: "Moteur",
    DriveBearing: "DriveBearing fr ",
    IdlerBearing: "IdlerBearingfr ",
    ChainBelt: "ChainBelt fr",
    DriveSprocket: "DriveSprocket fr",
    IdlerSprocket: "IdlerSprocket fr",
    Curve: "Curve fr",
    Wearstrip: "Wearstrip fr",
    Roller: "Roller fr",
    Components: "Components fr"
  },
  FORM: {
    TO: "De",
    FROM: "A",
    SUBJECT: "Objet",
    SELECT_PARTS: "Sélectionnez pièce(e)s",
    MESSAGE: "Message"
  },
  MENU: {
    NEW: "Nouveau",
    ACTIONS: "Actes",
    CREATE_POST: "Créer un nouveau Post",
    PAGES: "Pages",
    FEATURES: "Fonctionnalités",
    APPS: "Applications",
    DASHBOARD: "Tableau de Bord"
  },
  AUTH: {
    GENERAL: {
      OR: "Ou",
      SUBMIT_BUTTON: "Soumettre",
      NO_ACCOUNT: "Ne pas avoir de compte?",
      SIGNUP_BUTTON: "Registre",
      FORGOT_BUTTON: "Mot de passe oublié",
      BACK_BUTTON: "Back",
      PRIVACY: "Privacy",
      LEGAL: "Legal",
      CONTACT: "Contact"
    },
    LOGIN: {
      TITLE: "Créer un compte",
      BUTTON: "Sign In"
    },
    FORGOT: {
      TITLE: "Forgot Password?",
      DESC: "Enter your email to reset your password",
      SUCCESS: "Your account has been successfully reset."
    },
    REGISTER: {
      TITLE: "Sign Up",
      DESC: "Enter your details to create your account",
      SUCCESS: "Your account has been successfuly registered."
    },
    INPUT: {
      EMAIL: "Email",
      FULLNAME: "Fullname",
      PASSWORD: "Mot de passe",
      CONFIRM_PASSWORD: "Confirm Password",
      USERNAME: "Nom d'utilisateur"
    },
    VALIDATION: {
      INVALID: "{{name}} n'est pas valide",
      REQUIRED: "{{name}} est requis",
      MIN_LENGTH: "{{name}} minimum length is {{min}}",
      AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
      NOT_FOUND: "The requested {{name}} is not found",
      INVALID_LOGIN: "The login detail is incorrect",
      REQUIRED_FIELD: "Required field",
      MIN_LENGTH_FIELD: "Minimum field length:",
      MAX_LENGTH_FIELD: "Maximum field length:",
      INVALID_FIELD: "Field is not valid"
    }
  },
  ECOMMERCE: {
      SHOP: "Shop",
      CATALOG: "Votre catalogue",
      SHOP_NOW: "visitez notre boutique",
      WELCOME: "Bienvenue",
      ADDTOCART: "ajouter au panier",
      VIEW_PRODUCT: "Voir produit",
      VIEW: "Voir",
      VIEW_ALL: "Voir tous",
      MINIMUM_QUANTITIY: "Quantités d'achat minimum",
      PRICE: "Prix",
      PRODUCT_ADDED: "Produit ajouté au panier",
      ORDER: "Commande",
      ORDERS: "Commandes",
      ORDERS_STATUS: "Vos commandes",
      CART: "Panier",
      USER: "Utilisateur",
      TOTAL_PRICE: "Prix total",
      ORDER_OVERVIEW: "Vos commandes",
      CART_OVERVIEW: "Votre panier",
      DATE: "Date",
      IN_PROGRESS: "En cours",
      APPROVED: "Approuvé",
      COMPLETED: "Terminé",
      CANCELED: "Annulé",
      OPEN_ORDER_DETAILS: "Afficher la commande #",
      PRODUCTS: "Produits",
      QTY: "Qte",
      SU: "UV",
      DELETE: "Suppr.",
      PU: "PU",
      TOTAL: "Total",
      SUBTOTAL: "Sous-total",
      TOTAL_EX_VAT: "Total HT",
      CHECKOUT: "Poursuivre",
	  YOUR_NOTE: "Votre note",
	  ADD_ORDER_NOTE: "Ajoutez une note pour votre commande...",
	  EX_VAT_DELIVERY_MSG: "Prix HT et hors frais de livraison",
	  PLACE_ORDER_NOW: "Passez commande",
	  MY_CART: "Mon panier",
	  CART_IS_EMPTY: "Votre panier est vide",
	  PRODUCT_ADDED_TO_CART: "Produit ajouté au panier",
	  REFRESH: "Actualiser",
	  CLOSE: "Fermer",
	  PRINT_PDF: "Imprimer PDF",
	  NO_ORDERS_FOUND_PLACE_FIRST_ORDER: "Vous n'avez encore passé aucune commande",
    COMMON: {
      SELECTED_RECORDS_COUNT: "Nombre d'enregistrements sélectionnés: ",
      ALL: "All",
      SUSPENDED: "Suspended",
      ACTIVE: "Active",
      FILTER: "Filter",
      BY_STATUS: "by Status",
      BY_TYPE: "by Type",
      BUSINESS: "Business",
      INDIVIDUAL: "Individual",
      SEARCH: "Search",
      IN_ALL_FIELDS: "in all fields"
    },
    CUSTOMERS: {
      CUSTOMERS: "Les clients",
      CUSTOMERS_LIST: "Liste des clients",
      DELETE_CUSTOMER_SIMPLE: {
        TITLE: "Suppression du client",
        DESCRIPTION: "Êtes-vous sûr de supprimer définitivement ce client?",
        WAIT_DESCRIPTION: "Le client est en train de supprimer ...",
        MESSAGE: "Le client a été supprimé"
      },
      DELETE_CUSTOMER_MULTY: {
        TITLE: "Supprimer les clients",
        DESCRIPTION:
          "Êtes-vous sûr de supprimer définitivement les clients sélectionnés?",
        WAIT_DESCRIPTION: "Les clients suppriment ...",
        MESSAGE: "Les clients sélectionnés ont été supprimés"
      },
      UPDATE_STATUS: {
        TITLE: "Le statut a été mis à jour pour les clients sélectionnés",
        MESSAGE:
          "Le statut des clients sélectionnés a été mis à jour avec succès"
      },
      EDIT: {
        UPDATE_MESSAGE: "Le client a été mis à jour",
        ADD_MESSAGE: "Le client a été créé"
      }
    }
  }
};
